// components/ServiceStructuredData.tsx
import React from "react";
import { Helmet } from "react-helmet";

const ServiceStructuredData = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Example Service",
    "description":
      "Example Service provides professional solutions globally. Designed for seamless online operations, offering expertise, innovation, and efficiency.",
    "alternateName": "Example Online Solutions",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Example.com",
      "url": "https://www.example.com/",
      "image": "https://www.example.com/favicon.ico",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "support@example.com",
        "contactType": "customer support",
        "telephone": "+1-800-123-4567",
        "availableLanguage": ["English", "Spanish", "French"],
        "areaServed": [
          { "@type": "Country", "name": "United States" },
          { "@type": "Country", "name": "United Kingdom" },
          { "@type": "Country", "name": "Canada" },
          { "@type": "Country", "name": "Australia" },
          { "@type": "Country", "name": "Germany" }
        ]
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123 Example Street",
        "addressLocality": "Example City",
        "addressRegion": "Example State",
        "postalCode": "12345",
        "addressCountry": "US"
      },
      "logo": "https://www.example.com/favicon.ico",
      "sameAs": [
        "https://www.facebook.com/example",
        "https://www.instagram.com/example",
        "https://www.linkedin.com/company/example",
        "https://twitter.com/example"
      ]
    },
    "serviceType": "Example Service",
    "category": ["Online Services", "Consulting", "Digital Solutions"],
    "serviceOutput": {
      "@type": "Thing",
      "name": "Optimized Online Performance",
      "description":
        "Boost efficiency, enhance digital operations, and maximize online reach."
    },
    "brand": { "@type": "Brand", "name": "Example" },
    "audience": {
      "@type": "Audience",
      "audienceType": "Businesses, Entrepreneurs, Startups"
    },
    "isRelatedTo": {
      "@type": "WebSite",
      "url": "https://www.example.com/blog"
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.example.com/example-service",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "199.99",
        "priceCurrency": "USD",
        "valueAddedTaxIncluded": true
      },
      "eligibleCustomerType": {
        "@type": "BusinessEntityType",
        "name": "Online Businesses"
      },
      "validFrom": "2025-01-01"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Example Service Catalog",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Example Consultation",
            "description":
              "One-on-one expert consultations tailored to business needs."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Example Strategy Development",
            "description":
              "Strategic planning and execution for business growth."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Example Implementation",
            "description":
              "Seamless execution and operational support for online businesses."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Example Support",
            "description":
              "Ongoing assistance to maintain and optimize digital operations."
          }
        }
      ]
    },
    "providerMobility": "online",
    "termsOfService": "https://www.example.com/terms",
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": "https://www.example.com/contact",
      "availableLanguage": ["English", "Spanish", "French"],
      "providesService": {
        "@type": "Service",
        "name": "Example Service"
      }
    },
    "sameAs": [
      "https://www.facebook.com/example",
      "https://www.instagram.com/example",
      "https://www.linkedin.com/company/example",
      "https://twitter.com/example"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default ServiceStructuredData;
